import './@types.js';

import { waitForPromise } from '@remento/web-utils/dom/initialization';

export function waitForCELoaded(timeout: number | null = null): Promise<void> {
  return waitForPromise(
    new Promise((resolve) => {
      (window.CE_API || (window.CE_API = [])).push(function () {
        // CrazyEgg is still missing some properties at this point, hence the timeout
        setTimeout(resolve, 100);
      });
    }),
    timeout,
  );
}
